import { useSelector } from 'react-redux';
import React, { useCallback } from 'react';
import { AppState } from '../../../../stores/redux-store';
import { ProviderEntity } from '../../../../models/provider';
import { PageView, UserInteractionEvent } from '../../../../models/analytics';
import { InteractionElement } from '../../../../core/Analytics/ParentApplicationEventMessenger';
import { BackButton } from '../../../../components/organisms/Header/HeaderMolecule';
import { usePageViewEvents } from '../../../../core/Analytics/usePageViewEvents';
import { QrHandoffView as QrHandoffViewImport, QrHandoffViewProps } from './QrHandoffView';

export type QrHandoffProps = {
  userHintId: string | undefined;
  provider: ProviderEntity;
  qrCodeValue: string;
  forceWebFlow: VoidFunction;
  QrHandoffView?: React.ComponentType<QrHandoffViewProps>;
  pageView?: PageView;
  credentialsError?: string;
} & BackButton;

export const QrHandoff = ({
  userHintId,
  provider,
  qrCodeValue,
  forceWebFlow,
  onBack,
  credentialsError,
  pageView = PageView.HANDOFF_QR_CODE_SCREEN,
  QrHandoffView = QrHandoffViewImport,
}: QrHandoffProps) => {
  const { sendViewInteractionEvent } = usePageViewEvents({ pageView });
  const {
    credentials: { error = credentialsError },
    oauth: { description },
  } = useSelector((state: AppState) => state);

  const onSignInCallback = useCallback(() => {
    sendViewInteractionEvent({
      interaction: UserInteractionEvent.HANDOFF_FORCE_DESKTOP_FLOW,
      element: InteractionElement.SECONDARY_BUTTON,
    });

    forceWebFlow();
  }, [forceWebFlow, sendViewInteractionEvent]);

  return (
    <QrHandoffView
      userHintId={userHintId}
      provider={provider}
      qrCodeValue={qrCodeValue}
      onBack={onBack}
      credentialsError={error}
      isClientVerified={Boolean(description?.verified)}
      onSignIn={onSignInCallback}
    />
  );
};
